import { connect } from "react-redux";
import NdisClaimReview from "./NdisClaimReview";
import {
  changeNDISClaimCaseNoteStatusRequest,
  getCaseNotesReviewRequest,
  getNdisClaimModeRequest,
  RemoveReviewCaseNoteList,
} from "store/actions/cos.actions";
import {
  changeNDISCaseNotesStatusLoadingSelector,
  changeStatusSuccessSelector,
  getCaseNoteReviewLoadingSelector,
  getCaseNoteReviewSelector,
  getCaseNotesListForClaimLoaderSelector,
  getCaseNotesListForClaimSelector,
  getSelectedClientsListSelector,
  getStatusFromNdisListSelector,
  ndisClaimModeSelector,
} from "store/selector/cos.selector";

const mapDispatchToProps = {
  emptyTableData: RemoveReviewCaseNoteList,
  changeStatus: changeNDISClaimCaseNoteStatusRequest,
  getCaseNotesReviewRequest,
  getNdisClaimMode: getNdisClaimModeRequest,
};

const mapStateToProps = (state) => {
  const caseNoteReview = getCaseNoteReviewSelector(state);
  const caseNotesListForClaim = getCaseNotesListForClaimSelector(state);
  const caseNotesListForClaimLoader =
    getCaseNotesListForClaimLoaderSelector(state);
  const caseNoteReviewLoading = getCaseNoteReviewLoadingSelector(state);
  const selectedClientList = getSelectedClientsListSelector(state);
  const changeStatusSuccess = changeStatusSuccessSelector(state);
  const statusList = getStatusFromNdisListSelector(state);
  const changeNDISCaseNotesStatusLoading =
    changeNDISCaseNotesStatusLoadingSelector(state);
  const ndisClaimMode = ndisClaimModeSelector(state);

  return {
    caseNoteReviewLoading,
    statusList,
    changeStatusSuccess,
    selectedClientList,
    caseNotesListForClaim,
    caseNoteReview,
    caseNotesListForClaimLoader,
    changeNDISCaseNotesStatusLoading,
    ndisClaimMode,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NdisClaimReview);
